import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSession } from '@/context/SessionContext'
import { useProfile } from '@/context/ProfileContext'
import AuthLoadingShell from './AuthLoadingShell'
import { buildLoginRedirect } from './authRouting'

export default function AdminRoute() {
  const { user, loading } = useSession()
  const { profile } = useProfile()
  const location = useLocation()

  // Wait for both session AND profile to hydrate. profile is fetched in a
  // separate effect after session resolves — evaluating `profile?.isAdmin`
  // during that window sees `undefined` and bounces legitimate admins home.
  if (loading || (user && !profile)) return <AuthLoadingShell variant="fullscreen" />

  if (!user) return <Navigate to={buildLoginRedirect(location)} replace />
  if (!profile?.isAdmin) return <Navigate to="/" replace />

  return <Outlet />
}
